import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

export default class LinearLoading extends Component {
    static propTypes = {
        color: PropTypes.string,
        style: PropTypes.object,
    };

    static defaultProps = {
        color: COLORS.PURPLE_PLUM,
    };

    render() {
        const { color, style } = this.props;

        const barStyle = {
            backgroundColor: `#${color}`,
        };

        return (
            <div style={style} className="linear-loading">
                <div className="bar" style={barStyle}></div>
            </div>
        );
    }
}
